import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const flexiBackdrop = {
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  content: '""',
  display: 'inline',
  zIndex: '10',
  position: 'absolute',
};

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
    '&.flexiVisual': {
      '& .plyr': {
        '&::before': {
          ...flexiBackdrop,
          background: theme.mixins.Black(250),
        },
        '& .plyr__control--overlaid': {
          [theme.breakpoints.down('md')]: {
            marginTop: pxToRem(16),
            border: 0,
          },
        },
      },
      '&.video-playing': {
        '& .plyr': {
          '&::before': {
            display: 'none',
          },
        },
        '& .contentWrapper': {
          width: '100%',
          height: '100vh',
          zIndex: 2000,
          position: 'fixed',
          top: 0,
          ...theme.mixins.left(0),
          '& > div': {
            width: '100%',
            height: '100vh',
            '&.imageBox': {
              display: 'none',
            },
          },
        },
      },
    },
    '& .MuiButton-root': {
      color: theme.mixins.White(),
      '&:not(.Mui-disabled):hover': {
        '& .MuiButton-endIcon, & .MuiButton-startIcon': {
          '& .MuiIcon-root': {
            animation: 'none',
          },
        },
      },
      '& .MuiButton-label': {
        textDecoration: 'none',
      },
      '& .MuiButton-endIcon': {
        color: theme.mixins.Black(),
        backgroundColor: theme.mixins.White(),
      },
    },
    '& .playIcon': {
      width: pxToRem(64),
      height: pxToRem(63),
      top: '50%',
      ...theme.mixins.left('50%'),
      marginTop: 0,
      ...theme.mixins.marginLeft(pxToRem(-48 / 2)),
      color: theme.mixins.White(),
      borderWidth: pxToRem(2),
      borderColor: theme.mixins.White(),
      borderStyle: 'solid',
      zIndex: 9,
      padding: 0,
      [theme.breakpoints.up('lg')]: {
        width: pxToRem(109),
        height: pxToRem(109),
        ...theme.mixins.marginLeft(pxToRem(-109 / 2)),
      },
      '& svg': {
        height: pxToRem(18),
        position: 'relative',
        left: pxToRem(2),
        width: pxToRem(18),
        [theme.breakpoints.up('lg')]: {
          height: theme.spacing(5),
          width: theme.spacing(5),
        },
      },
      '&:hover': {
        background: theme.mixins.Black(500),
        transition: 'background 0.3s ease-in-out',
      },
    },
    '& .singleFeatureImage': {
      '& .clickable-item': {
        '&.fallBackColor': {
          background: theme.mixins.Grey(200),
          [theme.breakpoints.down('md')]: {
            minHeight: '30vh',
          },
        },
      },
      [theme.breakpoints.up('lg')]: {
        '& .clickable-item': {
          '& .picture-with-play-icon': {
            height: '100%',
          },
        },
      },
    },

    '& .plyr > .plyr__control--overlaid.plyr__control': {
      width: '100%',
      height: '100%',
      borderRadius: borderRadius.b0,
      margin: 0,
      '&::before': {
        content: '""',
        width: '64px',
        height: '64px',
        position: 'absolute',
        border: '3px solid white',
        borderRadius: borderRadius.circle,
        top: '50%',
        transform: 'translateX(-50%)',
        marginTop: '-32px',
        [theme.breakpoints.up('lg')]: {
          width: '80px',
          height: '80px',
          marginTop: '-40px',
        },
      },
      [theme.breakpoints.up('lg')]: {
        top: 0,
      },
    },
  },
  flexiWrapper: {
    overflow: 'hidden',
    '& :not(.img-to-animate-wrapper) picture, & .img-to-animate-wrapper': {
      transition: 'all 1s ease',
    },
    '&:hover': {
      '& :not(.img-to-animate-wrapper) picture, & .img-to-animate-wrapper': {
        transform: 'scale(1.1, 1.1)',
      },
    },
  },
  overlayWrapper: {
    '&  .MuiPaper-root': {
      [theme.breakpoints.down('md')]: {
        margin: 0,
      },
      '& .MuiDialogContent-root': {
        [theme.breakpoints.down('md')]: {
          padding: 0,
        },
      },
    },
    '& .MuiDialogTitle-root, & .MuiDialogContent-root': {
      width: '100%',
      marginTop: theme.spacing(4),
      overflow: 'visible',
      paddingBottom: 0,
      [theme.breakpoints.up('lg')]: {
        width: '100%',
        zIndex: '10',
        margin: 'auto',
        paddingTop: theme.spacing(3),
      },
    },
    '&.video-playing': {
      '& .MuiDialog-container': {
        height: 'auto',
        '& .overlayCloseBtn': {
          zIndex: 0,
        },
      },
      '& .MuiDialog-paper': {
        maxWidth: 'none',
        borderRadius: borderRadius.b0,
        '& .MuiDialogTitle-root': {
          display: 'none',
        },
        '& .MuiDialogContent-root': {
          overflow: 'hidden',
          padding: 0,
          width: '100%',

          '& .plyr--video': {
            height: '100vh',
          },

          '& .location-info, & .slick-thumb, & .slick-arrow': {
            // added important here because slick slider
            // add inline style displya block
            display: 'none !important',
          },
        },
      },
    },
  },
  location: {
    paddingTop: theme.spacing(4),
    textAlign: 'center',
  },
  ctaButton: {
    fontFamily: theme.custom.fontFamily.primaryBold,
    fontSize: fontSize.s16Rem,
    '& .MuiButton-endIcon': {
      width: pxToRem(40),
      height: pxToRem(40),
      padding: pxToRem(8),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: fontSize.s24Rem,
      '& .MuiButton-endIcon': {
        width: pxToRem(48),
        height: pxToRem(48),
        padding: pxToRem(11),
      },
    },
  },
  flexiVisualComponentHeading: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      marginBottom: pxToRem(60),
    },
  },
  imageBox: {
    zIndex: 11,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      paddingLeft: '8%',
      paddingRight: '8%',
    },
    '&.videoImageBox': {
      [theme.breakpoints.up('lg')]: {
        top: 'calc(50% - 28px)',
      },
    },
  },
  contentWrapper: {
    zIndex: 2,
    top: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: 'auto',
    color: theme.mixins.White(),
    '&::before': {
      ...flexiBackdrop,
      background: theme.mixins.Black(250),
    },
  },
  pointerCursor: {
    cursor: 'initial',
  },
  labelDescription: {
    marginBottom: pxToRem(8),
    color: theme.mixins.White(),
    textAlign: 'center',
  },

  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      maxWidth: pxToRem(50),
      height: 'auto',
      marginRight: pxToRem(16),
    },
  },
  iconText: {
    color: theme.mixins.White(),
  },

  divider: {
    width: pxToRem(114),
    marginBottom: pxToRem(10),
    marginTop: 0,
    [theme.breakpoints.up('lg')]: {
      width: pxToRem(163),
      marginBottom: pxToRem(14),
    },
  },
  buttonWrapper: {
    textAlign: 'center',
    marginTop: pxToRem(27),
    [theme.breakpoints.up('lg')]: {
      marginTop: pxToRem(72),
    },
  },
  locationInfo: {
    textAlign: 'center',
    padding: theme.spacing(2),
  },
}));

export default useStyles;
